var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a8a8a8",
    d: "m46.460385,43.277458l-10.170236,-10.712585c-0.055255,-0.056934 -0.12007,-0.096728 -0.177811,-0.149722c2.045786,-3.197543 3.239799,-7.025098 3.239799,-11.141262c0,-11.197013 -8.80931,-20.273889 -19.676069,-20.273889s-19.676069,9.076876 -19.676069,20.273692c0,11.196619 8.809118,20.273692 19.675877,20.273692c3.99502,0 7.709556,-1.230279 10.812842,-3.338202c0.051431,0.059298 0.089862,0.126081 0.145117,0.183015l10.397184,10.712979c1.561872,1.609114 4.094059,1.609114 5.656122,0c1.561681,-1.609311 1.334923,-4.218408 -0.226757,-5.827719zm-26.784316,-8.758323c-7.099835,0 -12.855187,-5.93016 -12.855187,-13.245442c0,-7.315479 5.755543,-13.245639 12.855187,-13.245639c7.099453,0 12.854996,5.930357 12.854996,13.245639c0,7.315282 -5.755543,13.245442 -12.854996,13.245442z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch1);
export default __webpack_public_path__ + "static/media/search1.0bef36f87eaab5ce57e1f1ee41f32515.svg";
export { ForwardRef as ReactComponent };